// extracted by mini-css-extract-plugin
export default {"ClosedJobworkListPage":"ClosedJobworkListPage_ClosedJobworkListPage__7789u"};